export const CHANGE_SIDEBAR_VISIBILITY = 'CHANGE_SIDEBAR_VISIBILITY';
// export const CHANGE_MOBILE_SIDEBAR_VISIBILITY = 'CHANGE_MOBILE_SIDEBAR_VISIBILITY';

export const changeSidebarVisibility = () => ({ type: CHANGE_SIDEBAR_VISIBILITY });

// export function changeMobileSidebarVisibility() {
//   return {
//     type: CHANGE_MOBILE_SIDEBAR_VISIBILITY
//   };
// }



// WEBPACK FOOTER //
// ./src/modules/App/redux/actions/basics_action/sidebarActions.js